import React, { useEffect, useMemo } from "react";
import { YMInitializer } from "react-yandex-metrika";
import Router from "./routes";
import i18n from "./i18n";
import { getTheme } from "./theme";
import { useTypedDispatch, useTypedSelector } from "./hooks/useTypedRedux";
import { setTheme } from "./redux/reducers/appSlice";
import { ThemeProvider } from "styled-components";
import { selectThemeType } from "./redux/selectors/appSelector";
import { ProjectSettings } from "./config";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useCurrentLanguage } from "./fsd/shared/lib";

const services = ProjectSettings.services();

function App() {
  const settings = ProjectSettings.settings();
  const mirror = Object.keys(settings.MIRRORS).find(
    (item) => item === window.location.host
  );

  const lang = useCurrentLanguage();

  const dispatch = useTypedDispatch();
  const theme_type = useTypedSelector(selectThemeType);

  const site = settings.SEO.SITE_NAME;

  useEffect(() => {
    dispatch(
      setTheme(
        localStorage.getItem(`${site}_theme_mode`) || settings.THEME.DEFAULT
      )
    );
  }, []);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem(`${site}_language`) || lang);
    document.documentElement.setAttribute("lang", lang);

    if (lang === "ar") {
      document.body.style.direction = "rtl";
    } else document.body.style.direction = "ltr";
  }, [lang, site]);

  document.body.dir = i18n.dir();
  // @ts-ignore
  return (
    <>
      {/*// @ts-ignore*/}
      <ThemeProvider theme={getTheme(theme_type)}>
        <Router />
        {
          // @ts-ignore
          <YMInitializer
            accounts={[+(services?.YM?.KEY ?? "")]}
            options={{
              clickmap: true,
              trackLinks: true,
              accurateTrackBounce: true,
              webvisor: true,
            }}
          />
        }
      </ThemeProvider>
    </>
  );
}

export default App;
